import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SliderItem from './slider-item';
import 'swiper/swiper-bundle.min.css'
//import 'swiper/scss.min.css';
//import 'swiper/scss/navigation';
//import 'swiper/scss/pagination';

Slider.propTypes = {
    data : PropTypes.array,
};

function Slider(props) {
    const {data} = props;
    return (
        <section className="slider">
            <Swiper>
                {
                    data.slice(0,3).map(item => (
                        <SwiperSlide key={item.id}>
                            <SliderItem item={item} />
                        </SwiperSlide>
                        
                    ))
                }
            </Swiper>

        </section>
    );
}

export default Slider;